import { useNavigate, useSearchParams } from "react-router-dom";
import {
  SchedulesListPage as SchedulesListPageView,
  type SchedulesListFilters,
} from "@/components/SchedulesListPage";

export function SchedulesListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const statuses = searchParams.getAll("statuses");
  const defaultFilters: SchedulesListFilters = {
    statuses:
      statuses.length > 0 ? (statuses as SchedulesListFilters["statuses"]) : undefined,
  };

  function handleFiltersChange(filters: SchedulesListFilters) {
    const next = new URLSearchParams();
    filters.statuses?.forEach((s) => next.append("statuses", s));
    setSearchParams(next, { replace: true });
  }

  return (
    <SchedulesListPageView
      onScheduleClick={(id) => navigate(`/schedules/${id}`)}
      onCreateSchedule={() => navigate("/schedules/new")}
      onCustomerClick={(id) => navigate(`/customers/${id}`)}
      onContractExtracted={(terms) =>
        navigate("/schedules/new", { state: { contractTerms: terms } })
      }
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
